/**
 * Team Chat — store gate (follows the backend rollout switch).
 *
 * The backend decides which stores get Team Chat (channels, DMs, meetings):
 * `TEAM_CHAT_PILOT_RESTAURANT_IDS` (`*` = every store, a comma list = those
 * stores, unset = Happy Solutions (Main) only — `services/teamChat/chatPilot.js`)
 * and refuses the rest with 403 `TEAM_CHAT_NOT_ENABLED`. The app no longer
 * hardcodes the pilot store: any known store is offered the module, and a
 * refused bootstrap lands in `status: 'forbidden'` (TeamChatContext), which
 * hides every entry point.
 */

/**
 * Whether Team Chat may be offered for the active store / place (any known one;
 * the backend bootstrap is the authority).
 * @param {object|string|null} store Store or place doc, or an id.
 * @returns {boolean}
 */
export const isTeamChatPilotStore = (store) => {
    if (!store) {
        return false;
    }
    if (typeof store === 'string') {
        return store.trim().length > 0;
    }

    return typeof store === 'object';
};

/**
 * Redux selector form of {@link isTeamChatPilotStore}.
 * @param {object} state
 * @returns {boolean}
 */
export const selectIsTeamChatPilotStore = (state) => isTeamChatPilotStore(state?.device?.restaurant);

export default isTeamChatPilotStore;
